import { render, staticRenderFns } from "./ButtonLoader.vue?vue&type=template&id=3b479e6d&"
import script from "./ButtonLoader.vue?vue&type=script&lang=ts&"
export * from "./ButtonLoader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports